import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';
import { NavigationButtonType } from '../gzNavigationButton/types';

export const templateNetworkAppContainer = document.createElement('template');

templateNetworkAppContainer.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${widgetSharedStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <gz-push-body-layout id="network-container" resizable="right">

      <div slot="push-body-sidenav-title" class="border" id="pushBodySidenav">
        <gz-navigation-button buttonType="${NavigationButtonType.TOP}" id="navButtonTop"></gz-navigation-button>
      </div>
        <div class="network-sidenav" slot="push-body-sidenav">
          <gz-network-scrollable-wrapper id="network-scrollable-wrapper">
          <gz-toggle id="depth-toggle"></gz-toggle>

          <div class="network-panel-content" id="network-panel-content">
            <gz-accordion isOpen="true" isCompact="true" align="left" id="network-tour-tree-accordion">
              <span slot="dynamic-title-content" class="accordion-slot d-inline-flex">
                <gz-tooltip class="accordion-title" isEllipsis></gz-tooltip>
              </span>

              <div id="network-tree">
                <gz-network-tree data-has-actions></gz-network-tree>
              </div>
            </gz-accordion>
          </div>

          <div id="network-smart-views" class="border">
            <gz-generic-grid-smart-views
              hasSearchInput="true"
              .searchInputPlaceholder="Search Network View"
              .searchInputNoResultsFoundText="No network view found"
            ></gz-generic-grid-smart-views>
          </div>
          </gz-network-scrollable-wrapper>
            <gz-navigation-button buttonType="${
              NavigationButtonType.BOTTOM
            }" id="navButtonBottom"></gz-navigation-button>
          </div>
       </div>


      <div class="network push-body"  slot="push-body-content">
        <div class="push-body--menu"></div>

        <div class="push-body--content">
          <div class="wrapper">
              <div class="network-header">
                <div class="page__header">
                  <gz-title id="network-title" class="title" fontWeight='${FontWeights.MEDIUM}' fontSize='${
  FontSizes.TITLE
}'></gz-title>
                </div>
                <gz-button id="feedback-btn" class="feedback-btn" type="quiet" fontSize="14" lowercase>
                    <span class="icon ds-icon-feedback_notes"></span><span id="feedback-btn-text"></span>
                </gz-button>
              </div>

              <div class="network-content">
                <div class="network-grid">
                  <gz-grid-view>
                    <div slot="grid-header-title-status-slot">
                      <grid-view-status-chip id="network-drill-down-status" class="hidden"></grid-view-status-chip>
                    </div>
                    <div class="header-buttons d-flex" slot="grid-header-actions-slot">
                        <gz-generic-overlay class="mr-2" id="actions-overlay" style="--overlay-min-width: 500px">
                          <gz-button slot="target" id="global-actions-button" class="global-actions-button"><span class="icon ds-icon-dropdown_arrow"></gz-button>
                          <gz-mega-menu id="actions-mega-menu"></gz-mega-menu>
                        </gz-generic-overlay>
                        <gz-button id="reports-button" class="mr-2" type="quiet" color="secondary" theme="light"></gz-button>
                        <gz-button id="go-to-container" type="quiet" color="secondary"></gz-button>
                        <gz-button id="recovery-manager-button" class="ml-2 hidden" type="quiet" color="secondary" theme="light"></gz-button>
                        <gz-button id="delete-entities" class="global-actions-button ml-2"></gz-button>
                    </div>
                    <div slot="no-results--additional-data">
                       <gz-text id="networkAdditionalText" fontSize="14"></gz-text>
                       <gz-link id="emptyStateKbLink"><span id="emptyStateKbLinkText"></span></gz-link>
                    </div>
                  </gz-grid-view>
                  <gz-context-menu-overlay id="extra-details-context-menu" class="fit-content">
                    <gz-multi-level-list
                    ></gz-multi-level-list>
                  </gz-context-menu-overlay>
                </div>
                <gz-side-menu id="networkPanel" menuwidth="400" closeOnClickOutside resizable="left" isResponsive="true"></gz-side-menu>

                <div class="grid-loader">
                  <div class="d-flex justify-space-between">
                    <gz-loader rows="1" columns="1" class="loader-margin loader-width"></gz-loader>
                    <div class="d-flex width-auto align-items-center">
                      <gz-loader rows="1" columns="1" class="loader-margin save-loader"></gz-loader>
                      <div class="divider"></div>
                      <div>
                        <gz-loader rows="1" columns="4" class="loader-margin grid-settings-loader"></gz-loader>
                      </div>
                    </div>
                  </div>
                  <gz-loader rows="1" columns="4" class="loader-margin loader-width"></gz-loader>
                  <gz-loader rows="1" columns="5" splitRowsByLine class="border-top"></gz-loader>
                  <gz-loader rows="7" columns="5" splitRowsByLine></gz-loader>
                  <div class="loading-footer-wrapper">
                    <gz-loader rows="1" columns="5" class="footer-loader" splitColumnsByLine></gz-loader>
                  </div>
                </div>
              </div>

              <gz-image-repo state="error" class="loading-error">
                <gz-text fontSize="14" fontWeight="400" class="loading-error--message" />
              </gz-image-repo>
              <gz-progress-spinner class="hidden" id="globalLoading" indeterminate spinnerWidth="custom" customSpinnerWidthValue="110"></gz-progress-spinner>
          </div>
        </div>
        ${/* TBD: error screens */ ''}
      </div>

  </gz-push-body-layout>


`;
